import { CssUtil } from "../../utils/css-util";
import { StyleManagerBase } from "./style-manager-base";

export class PageStyleManager extends StyleManagerBase {

    public constructor(private readonly commonStyles: HTMLStyleElement) {
        super(commonStyles.ownerDocument);
    }

    public static create(doc: Document): PageStyleManager {
        const commonStyles = this.ensureSiteDesignStyles(doc);

        return new PageStyleManager(commonStyles);
    }

    public override flush(): void {
        CssUtil.flushSheet(this.commonStyles);

        super.flush();
    }

    public get CommonStyle(): HTMLStyleElement {
        return this.commonStyles;
    }

}
